import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '@Redux/detail/store';
import styles from '../styles.module.scss';

const TaxList: React.FC = () => {
    const {
        Meals,
        VisaPriceContain,
        VisaPrice,
        AirportPriceContain,
        AirportPrice,
        StraightRemarks,
        CurrencyCode,
    } = useSelector((state: RootState) => state.groupReducer.PricesInfo!);

    const MealTypeTrans = (type: number) => {
        if (type === 1) {
            return '大人';
        } else if (type === 2) {
            return '孩童';
        } else {
            return;
        }
    };
    return (
        <ul>
            {Meals && Meals.length > 0 && (
                <li>
                    餐費：
                    {Meals.map((mealitem) => (
                        <span key={mealitem.MealType} className={styles.meals}>
                            {MealTypeTrans(mealitem.MealType)} {CurrencyCode + ' '}
                            {mealitem.Price.toLocaleString()}
                        </span>
                    ))}
                </li>
            )}
            {(VisaPrice?.Cost || VisaPriceContain?.Cost) && (
                <li>
                    簽證費：
                    {/* 如果都有資料會顯示: 不包簽證 TWD 1,200、包簽證 TWD 100 */}
                    {VisaPrice?.CostDesc && `不包${VisaPrice.CostDesc} `}
                    {VisaPrice?.Cost && CurrencyCode + ' ' + VisaPrice.Cost.toLocaleString()}
                    {(VisaPrice?.CostDesc || VisaPrice?.Cost) &&
                        (VisaPriceContain?.CostDesc || VisaPriceContain?.Cost) &&
                        `、`}
                    {VisaPriceContain?.CostDesc && `包${VisaPriceContain.CostDesc} `}
                    {VisaPriceContain?.Cost &&
                        CurrencyCode + ' ' + VisaPriceContain.Cost.toLocaleString()}
                </li>
            )}
            {(AirportPrice?.Cost || AirportPriceContain?.Cost) && (
                <li>
                    機場稅：
                    {AirportPrice?.CostDesc && `不包${AirportPrice.CostDesc} `}
                    {AirportPrice?.Cost && CurrencyCode + ' ' + AirportPrice.Cost.toLocaleString()}
                    {(AirportPrice?.CostDesc || AirportPrice?.Cost) &&
                        (AirportPriceContain?.CostDesc || AirportPriceContain?.Cost) &&
                        `、`}
                    {AirportPriceContain?.CostDesc && `包${AirportPriceContain.CostDesc} `}
                    {AirportPriceContain?.Cost &&
                        CurrencyCode + ' ' + AirportPrice.Cost.toLocaleString()}
                </li>
            )}
            {StraightRemarks && StraightRemarks.length > 0 && (
                <li className={styles['cost-item']}>
                    <span className={styles['cost-item__title']}>{` 備註：`}</span>
                    <div dangerouslySetInnerHTML={{ __html: StraightRemarks }} />
                </li>
            )}
        </ul>
    );
};

export default TaxList;
